import React from "react";
import { amenityOptions } from "../types";

interface AmenityStepProps {
  selectedAmenities: string[];
  onAmenityToggle: (amenity: string) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

const AmenityStep: React.FC<AmenityStepProps> = ({
  selectedAmenities,
  onAmenityToggle,
  onKeyDown,
}) => {
  return (
    <div className="flex flex-wrap gap-2" onKeyDown={onKeyDown}>
      {amenityOptions.map((amenity) => (
        <button
          key={amenity}
          onClick={() => onAmenityToggle(amenity)}
          type="button"
          className={`px-3 py-1.5 rounded-full text-[13px] transition-colors duration-200 ${
            selectedAmenities.includes(amenity)
              ? "bg-indigo-100 text-indigo-700 border border-indigo-200"
              : "bg-neutral-100 text-neutral-600 border border-neutral-200 hover:bg-neutral-200"
          }`}
        >
          {amenity}
        </button>
      ))}
    </div>
  );
};

export default AmenityStep;
